import { render, staticRenderFns } from "./AuthPage.vue?vue&type=template&id=22baa0a6&scoped=true"
import script from "./AuthPage.vue?vue&type=script&lang=js"
export * from "./AuthPage.vue?vue&type=script&lang=js"
import style0 from "./AuthPage.vue?vue&type=style&index=0&id=22baa0a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22baa0a6",
  null
  
)

export default component.exports